import create from "./create";
import form from "./form";
import manage from "./manage";

const dadup = {
	create: create,
	form: form,
	manage: manage,
	nav: {
		create: "Create",
		manage: "Manage",
		title: "daDup Storage",
	},
	title: "Tuxis daDup Storage Account",
};

export default dadup;
